/**
 * `<WindowResizeGrips>` — invisible edge + corner grips that drive OS-level
 * window resizing in the Tauri desktop build.
 *
 * The window runs `decorations: false` (custom branded chrome), which strips
 * the native resize border on Windows — so the window can't be resized from
 * its edges. These eight fixed-position grips overlay the window border and,
 * on `mousedown`, hand off to the OS resize loop via the `window_start_resize`
 * IPC command (see desktopIpc.ts + ipc.rs).
 *
 * Renders nothing in the browser build (gated by the caller on isDesktopApp).
 * Grips sit ABOVE content (high z-index) but are only a few px thick on the
 * very edges, so they don't eat clicks on real UI.
 */

import { windowStartResize, type ResizeDirection } from './desktopIpc';

const GRIPS: { dir: ResizeDirection; className: string }[] = [
  { dir: 'North', className: 'win-resize win-resize--n' },
  { dir: 'South', className: 'win-resize win-resize--s' },
  { dir: 'East', className: 'win-resize win-resize--e' },
  { dir: 'West', className: 'win-resize win-resize--w' },
  { dir: 'NorthWest', className: 'win-resize win-resize--nw' },
  { dir: 'NorthEast', className: 'win-resize win-resize--ne' },
  { dir: 'SouthWest', className: 'win-resize win-resize--sw' },
  { dir: 'SouthEast', className: 'win-resize win-resize--se' },
];

export function WindowResizeGrips(): JSX.Element {
  return (
    <>
      {GRIPS.map((g) => (
        <div
          key={g.dir}
          className={g.className}
          aria-hidden="true"
          onMouseDown={(e) => {
            // Primary button only; hand straight to the OS resize loop.
            if (e.button !== 0) return;
            e.preventDefault();
            void windowStartResize(g.dir);
          }}
        />
      ))}
    </>
  );
}
